module.exports = __webpack_public_path__ + "img/service-close.8f0d99da.svg";